import React from 'react';

import './ToolTip.css';

class ToolTip extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      anchor:"?",
      tip:this.props.tip//"This is a tooltip."
    };

  }

  render() {

    return (
      <a className="RSS-toolTip" data-hover={this.state.tip}>{this.state.anchor}</a>
    );
  }

}

export default ToolTip;


// WEBPACK FOOTER //
// ./src/components/ToolTip.js